<template>
  <div id="app"></div>
</template>

<script>
import { mapMutations } from "vuex";
import { clearSession } from "../../utils/auth";
export default {
  name: "Logout",
  mounted: function () {
    // Clears access token, refresh token and role together. Setting "token" to an
    // empty string left the refresh token behind, so the next boot still looked
    // half-signed-in.
    clearSession();
    this.setToken("");
    this.$router.replace({ name: "login" }).catch(function () {});
  },
  methods: {
    ...mapMutations(["setToken"]),
  },
};
</script>
